import { Component } from '@angular/core';
import { NG_APP_S3_PUB_BULB_URL } from '@web-nx-ng-tsc/shared-constant';

@Component({
  template: '',
})
export class ReplaceBucket {
  replaceBucket(url: string): string {
    // If NG_APP_S3_PUB_BULB_URL is already included in the URL, return as-is
    if (url.includes(NG_APP_S3_PUB_BULB_URL)) {
      return url;
    }
    // Otherwise, replace the base URL with NG_APP_S3_PUB_BULB_URL
    const s3BaseUrl = NG_APP_S3_PUB_BULB_URL.replace('/public', '') + '/';

    if (url.startsWith(s3BaseUrl)) {
      const pathAfterBucket = url.replace(s3BaseUrl, '');
      return NG_APP_S3_PUB_BULB_URL + '/' + pathAfterBucket;
    }

    return url;
  }
}
